import React from 'react';
import {default as Button} from '@material-ui/core/Button';
import {default as Dialog} from '@material-ui/core/Dialog';
import {default as DialogActions} from '@material-ui/core/DialogActions';
import {default as DialogContent} from '@material-ui/core/DialogContent';
import {default as DialogContentText} from '@material-ui/core/DialogContentText';
import {default as DialogTitle} from '@material-ui/core/DialogTitle';
import {default as FormControl} from '@material-ui/core/FormControl';
import {default as FormControlLabel} from '@material-ui/core/FormControlLabel';
import {default as FormHelperText} from '@material-ui/core/FormHelperText';
import {default as FormGroup} from '@material-ui/core/FormGroup';
import {default as Switch} from '@material-ui/core/Switch';
import {default as Typography} from '@material-ui/core/Typography';
import {default as Slider} from '@material-ui/core/Slider';
import {default as Checkbox } from '@material-ui/core/Checkbox';
import {default as Input } from '@material-ui/core/Input';
import CloseIcon from '@material-ui/icons/Close';
import {default as IconButton} from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from "@material-ui/core";

enum Displayed {
  Filter,
  FilterMesh,
  FilterPM,
  Scripting,
  Settings,
  Help,
  Legend,
  Sources,
  Acknowledgements,
  NoDisplay
}

const CustomSlider = withStyles({
  root: {
      color: "#6f8eff",
      height: 3,
      width: 300,
      padding: "13px 0",
  },
  track: {
      height: 4,
      borderRadius: 2,
  },
})(Slider);

class MapMenu extends React.Component<any,any> {
  state = {
    anchorEl: null,
    zoom_bookmark: this.props.zoom_bookmarkBit === 'Z'?true:false,
    guide: this.props.guideBit === 'G'?true:false,
    open: false,
    overlay: 'C',
    starScale: 5,
    scriptImmediate: true,
    display: Displayed.NoDisplay,
    filterOptions: this.props.filterOptions,
    filterOptionsMesh: this.props.filterOptionsMesh,
    filterOptionsPM: this.props.filterOptionsPM,
    hasToCheckAll: true,
    hasToCheckAllMesh: true,
    hasToCheckAllPM: true,
    galacticplane: false,
    pillars: false,
    labels: false
  };

  handleClick = (event:any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleClose2 = () => {
    this.setState({ display: Displayed.NoDisplay });
  };

  handleCloseError = () => {
    this.setState({ display: Displayed.NoDisplay });
    this.props.setError('');
  };

  public handleClickOpen = () => {
    this.setState({ open: true });
  };

  public handleSettingsChange = (name: string) => (event: any) => {
    this.setState({ [name]: event.target.checked });
  };

  public handleDisplay = (kind: Displayed) => {
    this.setState({ display: kind });
    this.handleClose();
  };

  public handleSet = () => {
    const guide = this.state.guide?'G':'N';
    const zoom_bookmark = this.state.zoom_bookmark?'Z':'N';
    this.props.setOptions(guide,zoom_bookmark,this.state.overlay);
    this.handleClose2();
  };

  public handleSetFilterOptions = () => {
    const options = this.state.filterOptions.map((g:any) => {
      let o = g.children.map((item:any) => {
        return item.checked?item.itemCode:'';
      });
      return o.join('|');
    });
    this.props.setFilterOptions(options.join('|'));
    this.handleClose2();
  };

  public handleSetFilterOptionsPM = () => {
    const options = this.state.filterOptionsPM.map((g:any) => {
      let o = g.children.map((item:any) => {
        return item.checked?item.itemCode:'';
      });
      return o.join('|');
    });
    this.props.setFilterOptionsPM(options.join('|'));
    this.handleClose2();
  };

  public handleSetFilterOptionsMesh = () => {
    const options = this.state.filterOptionsMesh.map((item:any) => {
      return item.checked?item.itemCode:'';
    });
    this.props.setFilterOptionsMesh(options.filter((e:string) => {return e}).join('|'));
    this.handleClose2();
  };

  public handleOverlayChange = (event: any) => {
    this.setState({ overlay: event.target.value });
    console.log('radio', event.target.value);
  };

  public handleFilterChange = (event: any) => {
    console.log(event.target.name, event.target.checked);
    console.log(this.state);
    //this.setState({ filterOptions[event.target.name]: {'stuff': event.target.checked} });
    const filterOptions = { ...this.state.filterOptions, [event.target.name]: event.target.checked };
    this.setState(() => ({ filterOptions }));
    /*this.setState((prevState: any)=> ({
      filterOptions: {                   // object that we want to update
          ...prevState.filterOptions,    // keep all other key-value pairs
          [event.target.name]: event.target.checked       // update the value of specific key
      }
    }));*/
  };

  handleAllCheckboxes = () => {
    const hasToCheckAll = !this.state.hasToCheckAll;
    const updatedArray = this.state.filterOptions.map((g:any) => {
      g.children = g.children.map((item:any) => {
        item.checked = hasToCheckAll;
        return item;
      });
      return g;
    });

    this.setState({
        ...this.state,
        filterOptions: updatedArray,
        hasToCheckAll: hasToCheckAll,
    });
};

handleCheckboxClick = (clickedItem:any) => {
  console.log('clickedItem',clickedItem);
  const updatedArray = this.state.filterOptions.map((g:any) => {
    g.children = g.children.map((item:any) => {
      console.log('item',item);
      item.checked = item.itemCode === clickedItem.itemCode ? !item.checked : item.checked;
      return item;
    });
    return g;
  });

  console.log('updatedArray',updatedArray);

  this.setState({
      ...this.state,
      filterOptions: updatedArray,
  });
  console.log(clickedItem);
};

public handleFilterChangeMesh = (event: any) => {
  console.log(event.target.name, event.target.checked);
  console.log(this.state);
  //this.setState({ filterOptions[event.target.name]: {'stuff': event.target.checked} });
  const filterOptionsMesh = { ...this.state.filterOptionsMesh, [event.target.name]: event.target.checked };
  this.setState(() => ({ filterOptionsMesh }));
  /*this.setState((prevState: any)=> ({
    filterOptions: {                   // object that we want to update
        ...prevState.filterOptions,    // keep all other key-value pairs
        [event.target.name]: event.target.checked       // update the value of specific key
    }
  }));*/
};

handleAllCheckboxesMesh = () => {
  const hasToCheckAll = !this.state.hasToCheckAllMesh;
  const updatedArray = this.state.filterOptionsMesh.map((item:any) => {
      item.checked = hasToCheckAll;
      return item;
  });
  this.setState({
      ...this.state,
      filterOptionsMesh: updatedArray,
      hasToCheckAllMesh: hasToCheckAll,
  });
};

handleCheckboxClickMesh = (clickedItem:any) => {
  console.log('clickedItem',clickedItem);
  const updatedArray = this.state.filterOptionsMesh.map((item:any) => {
    item.checked = item.itemCode === clickedItem.itemCode ? !item.checked : item.checked;
    return item;
  });
  console.log('updatedArray',updatedArray);

  this.setState({
      ...this.state,
      filterOptionsMesh: updatedArray,
  });
  console.log(clickedItem);
}

public handleFilterChangePM = (event: any) => {
  console.log(event.target.name, event.target.checked);
  console.log(this.state);
  //this.setState({ filterOptions[event.target.name]: {'stuff': event.target.checked} });
  const filterOptionsPM = { ...this.state.filterOptionsPM, [event.target.name]: event.target.checked };
  this.setState(() => ({ filterOptionsPM }));
  /*this.setState((prevState: any)=> ({
    filterOptions: {                   // object that we want to update
        ...prevState.filterOptions,    // keep all other key-value pairs
        [event.target.name]: event.target.checked       // update the value of specific key
    }
  }));*/
};

handleAllCheckboxesPM = () => {
  const hasToCheckAll = !this.state.hasToCheckAllPM;
  const updatedArray = this.state.filterOptionsPM.map((g:any) => {
    g.children = g.children.map((item:any) => {
      item.checked = hasToCheckAll;
      return item;
    });
    return g;
  });

  this.setState({
      ...this.state,
      filterOptionsPM: updatedArray,
      hasToCheckAllPM: hasToCheckAll,
  });
};

handleCheckboxClickPM = (clickedItem:any) => {
  console.log('clickedItem',clickedItem);
  const updatedArray = this.state.filterOptionsPM.map((g:any) => {
    g.children = g.children.map((item:any) => {
      console.log('item',item);
      item.checked = item.itemCode === clickedItem.itemCode ? !item.checked : item.checked;
      return item;
    });
    return g;
  });

  console.log('updatedArray',updatedArray);

  this.setState({
      ...this.state,
      filterOptionsPM: updatedArray,
  });
  console.log(clickedItem);
};

public handleScriptFile = () => {
  const filename = document.getElementById('script-file') as HTMLInputElement;

  if (filename) {
      // Creating a FileReader object using the constructor.
      const filereader = new FileReader();
      // Reading a file as plain text
      if (filename.files) {
          filereader.readAsText(filename.files[0]);
          // Call this function to print the contents of the file
          // once the file has been read.
          filereader.onload = function () {
              console.log(filereader.result);
              if (filereader.result) {
                const script_csv = document.getElementById('gaia-script') as HTMLInputElement;
                script_csv.value = filereader.result as string;
              }
          };
          // Print the error incase there is one
          filereader.onerror = function () {
              console.log("Error: ", filereader.error);
          };
      }
  }
};

public handleSetScriptFile = () => {
  const scriptUpdate = document.getElementById('gaia-script-update') as HTMLInputElement;
  scriptUpdate.value = '1';
  const scriptImmediate = document.getElementById('gaia-script-immediate') as HTMLInputElement;
  if (this.state.scriptImmediate) {
    scriptImmediate.value = '1';
  } else {
    scriptImmediate.value = '0';
  }
  this.handleClose2();
};

public handleScriptImmediateCheckbox = (e:any) => {
  console.log('clickedItem',e.target.checked);
  this.setState({scriptImmediate: e.target.checked});
}

public handleSliderChange = (event: any, starScale: any) => {
  this.setState({ starScale });
}

public handleSettingsSubmit = () => {
  console.log('starScale',this.state.starScale);
  const star_scale = document.getElementById('gaia-star-scale') as HTMLInputElement;
  star_scale.value = this.state.starScale.toString();

  console.log('galacticplane',this.state.galacticplane);
  const galacticplane = document.getElementById('gaia-galacticplane') as HTMLInputElement;
  galacticplane.value = this.state.galacticplane?'1':'0';

  console.log('pillars',this.state.pillars);
  const pillars = document.getElementById('gaia-pillars') as HTMLInputElement;
  pillars.value = this.state.pillars?'1':'0';

  console.log('labels',this.state.labels);
  const labels = document.getElementById('gaia-labels') as HTMLInputElement;
  labels.value = this.state.labels?'1':'0';

  const settings_update = document.getElementById('gaia-settings-update') as HTMLInputElement;
  settings_update.value = '1';

  this.handleClose2();
}

  render() {
    const { anchorEl } = this.state;
    const { classes, errorMsg } = this.props;

    return (
      <div>
        <IconButton 
            className={classes.menuButton} 
            color="inherit" 
            aria-label="Open drawer"
            onClick={this.handleClick}
        >
            <MenuIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
            <MenuItem onClick={() => this.handleDisplay(Displayed.Filter)}>Filter (objects)</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.FilterMesh)}>Filter (meshes)</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.Scripting)}>Scripting</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.Settings)}>Settings</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.Help)}>Help</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.Legend)}>Legend</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.Sources)}>Sources</MenuItem>
            <MenuItem onClick={() => this.handleDisplay(Displayed.Acknowledgements)}>Acknowledgements</MenuItem>
        </Menu>
        <Dialog
          open={errorMsg != ""}
          onClose={this.handleCloseError}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Error</h2>
            <IconButton onClick={this.handleCloseError} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p>{errorMsg}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
          open={this.state.display == Displayed.Filter}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Filter by object category</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
        <FormControl component="fieldset">
          <FormControlLabel
            style={{marginBottom: 10}}
            control={
            <Checkbox
              style={{ width: 10, height: 5}}
              name="checkboxes"
              checked={this.state.hasToCheckAll}
              onChange={() => this.handleAllCheckboxes()}
              indeterminate
              />
            }
            label="Toggle All"
          />            
          </FormControl>
          {this.state.filterOptions.map((g:any) => {
            return <div key={g.name}><FormHelperText style={{marginTop: 10, marginBottom: 10, fontSize: '1.0em'}}>{g.name}</FormHelperText>
            {g.children.map((item:any) => {
            return <div key={item.itemCode}>
              <FormControlLabel
                control={
                <Checkbox
                    style={{ width: 10, height: 5 }}
                    name="DocCheckbox"
                    color="default"
                    checked={item.checked}
                    onChange={() => this.handleCheckboxClick(item)}/> }
                    label={item.itemLabel}
            /></div>
          })}
          </div>
          })}
          <FormHelperText style={{ marginTop: 15, fontSize: '1.0em' }}>Click on "Set" to redisplay stars.</FormHelperText>
        </DialogContent>
        <DialogActions>
        <Button onClick={this.handleClose2} color="default">
            Cancel
        </Button>
        <Button onClick={this.handleSetFilterOptions} color="default">
            Set
        </Button>
        </DialogActions>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.FilterMesh}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Toggle region meshes</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
        <FormControl component="fieldset">
          <FormControlLabel
            style={{marginBottom: 10}}
            control={
            <Checkbox
              style={{ width: 10, height: 5}}
              name="checkboxesMesh"
              checked={this.state.hasToCheckAllMesh}
              onChange={() => this.handleAllCheckboxesMesh()}
              indeterminate
              />
            }
            label="Toggle All"
          />            
          </FormControl>
          {this.state.filterOptionsMesh.map((item:any) => {
            return <div key={item.itemCode}>
              <FormControlLabel
                control={
                <Checkbox
                    style={{ width: 10, height: 5 }}
                    name="DocCheckboxPM"
                    color="default"
                    checked={item.checked}
                    onChange={() => this.handleCheckboxClickMesh(item)}/> }
                    label={item.itemLabel}
            /></div>
          })}
          <FormHelperText style={{ marginTop: 15, fontSize: '1.0em' }}>Click on "Set" to redisplay stars.</FormHelperText>
        </DialogContent>
        <DialogActions>
        <Button onClick={this.handleClose2} color="default">
            Cancel
        </Button>
        <Button onClick={this.handleSetFilterOptionsMesh} color="default">
            Set
        </Button>
        </DialogActions>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.Scripting}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Upload script</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
        <form className={classes.root} noValidate autoComplete="off">
          <Input id="script-file" type="file" onChange={this.handleScriptFile} /><br /><br />
          <FormControlLabel
                control={
                <Checkbox
                    style={{ width: 15, height: 15, marginLeft: 10 }}
                    name="scriptImmediate"
                    color="default"
                    checked={this.state.scriptImmediate}
                    onChange={this.handleScriptImmediateCheckbox}/> }
                    label="run immediately"
            />
        </form>
        <FormHelperText style={{ marginTop: 15 }}></FormHelperText>
        <FormHelperText style={{ marginTop: 15, fontSize: '1.0em' }}>Click on "Set" to update the script.</FormHelperText>
        </DialogContent>
        <DialogActions>
        <Button onClick={this.handleClose2} color="default">
            Cancel
        </Button>
        <Button onClick={this.handleSetScriptFile} color="default">
            Set
        </Button>
        </DialogActions>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.Settings}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Settings</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
        <DialogContentText style={{ marginBottom: 50, color: 'white' }}>Star scale size</DialogContentText>
        <CustomSlider
          id="star-size"
          min={1}
          max={10}
          value={this.state.starScale}
          onChange={this.handleSliderChange}
          aria-labelledby="discrete-slider-always"
          step={1}
          valueLabelDisplay="on"
        />
        </DialogContent>
        <FormControl component={"fieldset" as "div"} style={{position:"relative", left:"20px"}}>                  
            <FormGroup>
              <FormControlLabel
                  control={
                  <Switch
                      checked={this.state.galacticplane}
                      onChange={this.handleSettingsChange('galacticplane')}
                      value="galacticplane"
                  />
                  }
                  label="Show galactic plane"
              />
              <FormControlLabel
                  control={
                  <Switch
                      checked={this.state.pillars}
                      onChange={this.handleSettingsChange('pillars')}
                      value="pillars"
                  />
                  }
                  label="Show star pillars"
              />
              <FormControlLabel
                  control={
                  <Switch
                      checked={this.state.labels}
                      onChange={this.handleSettingsChange('labels')}
                      value="labels"
                  />
                  }
                  label="Show labels"
              />
            </FormGroup>
        </FormControl>
        <DialogActions>
        <Button onClick={this.handleClose2} color="default">
            Cancel
        </Button>
        <Button onClick={this.handleSettingsSubmit} color="default">
            Set
        </Button>
        </DialogActions>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.Help}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Help</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p>You can use the search box to fly to and display information about stars within
            10 parsecs (33 light years). The filter options allow you to toggle on and off
            specific groups of stars or the region meshes.</p>
            <p>The star display is centred on the Sun (represented by a yellow dot).</p>
            <p>You can use a mouse or touch controls to rotate around or zoom into the focus star,
              which by default is the Sun. If you search for another star, it becomes the focus star
              until you cancel the search result or click on the home icon at the upper right.</p>
            <p>You can double click on a star using a mouse to make it the focus, fly to it and 
              get more information.</p>
            <p>The scripting system allows the creation of automatic fly throughs and is documented
              elsewhere.</p>
          </DialogContentText>
        </DialogContent>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.Legend}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Legend</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <div id="legend"></div>
        </DialogContent>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.Sources}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Sources</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <p>Based on the catalog of stars, brown dwarfs and planets described in 
            "The 10 pc sample in the Gaia era", Reylé, Jardine et al, Astronomy &amp; Astrophysics (2021).</p>
          </DialogContentText>
        </DialogContent>
    </Dialog>
    <Dialog
          open={this.state.display == Displayed.Acknowledgements}
          onClose={this.handleClose2}
          aria-labelledby="form-dialog-title"
        >
        <DialogTitle disableTypography={true} style={{alignItems:"center",display:"flex",height:"20px",
        justifyContent: "space-between"}}>
            <h2 style={{color:"white"}}>Acknowledgements</h2>
            <IconButton onClick={this.handleClose2} style={{position:"relative", left:"10px"}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          <p>This work has made use of data from the European Space Agency (ESA) mission Gaia, processed by the Gaia Data Processing and Analysis Consortium (<a style={{color:'white'}} href="http://www.cosmos.esa.int/gaia">http://www.cosmos.esa.int/gaia</a>).</p>

          <p>Funding for the DPAC has been provided by national institutions, in particular the institutions participating in the Gaia Multilateral Agreement.</p>

          <p>This work has made use of the SIMBAD database, operated at CDS, Strasbourg, France.</p>

          <p>This visualisation application was created by Kevin Jardine (cartographer, twitter: @galaxy_map) and is based on 
            data from the paper "The 10 pc sample in the Gaia era", Reylé, Jardine et al, Astronomy &amp; Astrophysics (2021).
          </p>

          <p>Credit: ESA/Gaia/DPAC</p>

          <p>License: CC BY-SA 3.0 IGO</p>
          </DialogContentText>
        </DialogContent>
    </Dialog>
    </div>
    );
  }
}

export default MapMenu;
